import { useContext } from "react";

import { useTranslator } from "@eo-locale/react";

import { ButtonGroup, Button } from "../../button/button";

import { CropperContext, CropperContextType } from "../context";

function Footer() {
  const { translate } = useTranslator();
  const { status, destroyCrop, submitCrop } = useContext(
    CropperContext
  ) as CropperContextType;

  return (
    <ButtonGroup
      gap={4}
      w="full"
      display="flex"
      size={{ base: "lg", lg: "md" }}
      disabled={status === "disabled"}
      justifyContent={{ base: "space-between", lg: "flex-end" }}
    >
      <Button variant="secondary" onClick={destroyCrop}>
        {translate("common.cancel")}
      </Button>
      <Button variant="primary" onClick={submitCrop}>
        {translate("common.done")}
      </Button>
    </ButtonGroup>
  );
}

export { Footer };
